<template>
  <div>
    <!-- 关联 -->
    <div v-if="form.lid">
      <el-form :model="form" label-width="100px">
        <el-form-item label="销售点名称:">
          <!-- <el-input v-model="form.urgentlist.title" disabled style="width:500px;"></el-input> -->
          <span>{{form.urgentlist.title}}</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toStationById(form.lid)">查看销售点详情</el-button>
        </el-form-item>
        <el-form-item label="联系人:">
          <span>{{form.options.contact}}</span>
        </el-form-item>
        <el-form-item label="联系电话:">
          <span>{{form.options.mobile}}</span>
        </el-form-item>
        <el-form-item label="营业执照:" v-if="form.options.licensed">
          <div class="licensed">
            <img :src="form.options.licensed" />
          </div>
        </el-form-item>
        <el-form-item label="其他:" v-if="form.options.others.length">
          <img
            :src="item"
            alt
            v-for="(item,index) in form.options.others"
            :key="index"
            class="othersImg" />
        </el-form-item>
        <el-form-item label="撤销原因:" v-if="form.msg">
          <span>{{form.msg}}</span>
        </el-form-item>
      </el-form>
    </div>

    <!-- 新增 -->
    <div v-if="!form.lid">
      <el-form :model="form" label-width="100px">
        <el-form-item label="分类:">
          <div>{{form.options.urgentCompany.title}}</div>
        </el-form-item>

        <el-form-item label="销售点名称:">
          <div>{{form.options.title}}</div>
        </el-form-item>

        <el-form-item label="详细地址:">
          <div class="cityBox">
            <div>{{form.options.province}}</div>
            <div>{{form.options.city}}</div>
            <div>{{form.options.area}}</div>
            <div>{{form.options.addr}}</div>
          </div>
        </el-form-item>

        <el-form-item label="认证时间:" v-if="form.options.startTime">
          <div>{{form.options.startTime | dateFormat}}</div>
        </el-form-item>

        <el-form-item label="有效期:" v-if="form.options.endTime">
          <div>{{form.options.endTime | dateFormat}}</div>
        </el-form-item>

        <el-form-item label="联系人:" v-if="form.options.contact">
          <span>{{form.options.contact}}</span>
        </el-form-item>

        <el-form-item label="联系电话:" v-if="form.options.mobile">
          <span>{{form.options.mobile}}</span>
        </el-form-item>

        <el-form-item label="营业执照:" v-if="form.options.licensed">
          <div class="licensed">
            <img :src="form.options.licensed" />
          </div>
        </el-form-item>
        <el-form-item label="门头照片:" v-if="form.options.storeImgs.length !== 0">
          <img
            :src="item"
            v-for="(item,index) in form.options.storeImgs"
            :key="'storeImgs' + index"
            class="othersImg"
          />
        </el-form-item>
        <el-form-item label="店内照片:" v-if="form.options.insideImgs.length !== 0">
          <img
            :src="item"
            v-for="(item,index) in form.options.insideImgs"
            :key="'insideImgs' + index"
            class="othersImg" /> 
        </el-form-item>

        <el-form-item label="核查记录:" v-if="form.options.record">
          <tinymce
            :plugins="['image', 'imagetools']"
            :value="form.options.record"
            :height="200"
            :width="600"
            disabled
          ></tinymce>
        </el-form-item>

        <el-form-item label="其他:" v-if="form.options.others.length !== 0">
          <img
            :src="item"
            v-for="(item,index) in form.options.others"
            :key="'others' + index"
            class="othersImg"
          />
        </el-form-item>

        <el-form-item label="撤销原因:" v-if="form.msg">
          <span>{{form.msg}}</span>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn-content">
      <el-button type="primary" v-if="form.status === 0 || form.desstatus === 0" @click="agree">同意</el-button>
      <el-button
              type="danger"
              v-if="form.status === 0 || form.desstatus === 0"
              @click="dialogVisible = true"
      >不同意</el-button>
    </div>

    <el-dialog title="审核失败" :visible.sync="dialogVisible" width="300" @close="closeDialog">
      <el-input type="textarea" :rows="2" placeholder="请输入审核失败的原因" v-model="remark"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDisagree">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { show, update } from "@/api/common.js";
import tinymce from "@/components/Tinymce";

export default {
  filters: {},
  components: {
    tinymce
  },
  data() {
    return {
      id: "",
      form: {
        options: {
          urgentCompany: {},
          storeImgs: [],
          insideImgs: [],
          others: []
        },
        urgentlist: {}
      },
      dialogVisible: false,
      remark: ""
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getStationById();
  },
  methods: {
    getStationById() {
      show("urgentreview", this.id).then(res => {
        this.form = res.data;
      });
    },
    //跳转到应急点详情页面
    toStationById(id) {
      this.$router.push({
        path: `/user/gov/urgentList/edit/${id}`
      });
    },
    agree() {
      this.$confirm("是否同意该申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        update("urgentreview", this.id, { type: 1 }).then(res => {
          this.$message.success("审核完成");
          this.$router.push({
            path: `/user/gov/urgentreview`
          });
        });
      });
    },
    handleDisagree() {
      if (!this.remark) {
        this.$message.error("请输入失败原因");
      } else {
        update("urgentreview", this.id, { type: -1, remark: this.remark }).then(
          res => {
            this.$message.success("审核完成");
            this.$router.push({
              path: `/user/gov/urgentreview`
            });
          }
        );
      }
    },
    closeDialog() {
      this.remark = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.licensed {
  border: 1px solid #ccc;
  width: 150px;
  height: 150px;
  img {
    width: 100%;
    height: 100%;
  }
}
.othersImg {
  border: 1px solid #ccc;
  width: 150px;
  height: 150px;
  margin-right: 5px;
}
.cityBox {
  display: flex;
  justify-content: flex-start;
  div {
    margin-right: 20px;
  }
}
@media screen and (min-width: 320px) and (max-width: 980px) {
  .btn-content {
    display: flex;
    .el-button {
      flex: 1;
      margin: 0 40px;
    }
  }
}

</style>


